import { combineReducers } from 'redux'
import { SettingStatistical } from '../../action_types'

import { handleRequest, initialRequestState } from './helpers'

function getStatisticRequest(state = initialRequestState(), action) {
  return handleRequest(
    SettingStatistical.GET_STATISTICS_REQUEST,
    SettingStatistical.GET_STATISTICS_REQUEST_SUCCESS,
    SettingStatistical.GET_STATISTICS_REQUEST_FAIL,
    state,
    action
  )
}

export default combineReducers({
  getStatisticRequest,
})
